import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header/Header'
import { certificate1, certificate2, certificate3, partners1, partners10, partners11, partners12, partners13, partners14, partners2, partners3, partners4, partners5, partners6, partners7, partners8, partners9, whyus, whyus2 } from '../../assets/index'
import axios from 'axios';

const Media = () => {

  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getProducts();
  }, []);

  function getProducts() {
    axios
      .get("https://fuga.birsayt.xyz/fuga/videos.php/", {
        withCredentials: false,
      })
      .then((response) => {
        setProducts(response.data);
        setIsLoading(false);
      });
  }
  return (
    <>
    <Header/>
    <div className="mx-auto bg-[#FAFAFA] pt-[140px] pb-[144px]">
       <div className="md:max-w-container max-w-containerSm mx-auto">
    <p className="text-[#405d72] text-[20px] font-semibold mb-4">Media</p>
<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
  <div>
    <video
      className="h-[245px] w-full object-cover"
      controls
    >
      <source
        src="https://fuga.az/fuga/media/video5.mp4"
        type="video/mp4"
      />
      Tarayıcınız video etiketini desteklemiyor.
    </video>
  </div>

  <div>
    <video
      className="h-[245px] w-full object-cover"
      controls
    >
      <source
        src="https://fuga.az/fuga/media/video1.mp4"
        type="video/mp4"
      />
      Tarayıcınız video etiketini desteklemiyor.
    </video>
  </div>

  <div>
    <video
      className="h-[245px] w-full object-cover"
      controls
    >
      <source
        src="https://fuga.az/fuga/media/video2.mp4"
        type="video/mp4"
      />
      Tarayıcınız video etiketini desteklemiyor.
    </video>
  </div>

  <div>
    <video
      className="h-[245px] w-full object-cover"
      controls
    >
      <source
        src="https://fuga.az/fuga/media/video3.mp4"
        type="video/mp4"
      />
      Tarayıcınız video etiketini desteklemiyor.
    </video>
  </div>

  <div>
    <video
      className="h-[245px] w-full object-cover"
      controls
    >
      <source
        src="https://fuga.az/fuga/media/video4.mp4"
        type="video/mp4"
      />
      Tarayıcınız video etiketini desteklemiyor.
    </video>
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image1.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image2.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image3.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image4.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image5.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image6.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image7.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image8.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image9.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>

  <div>
    <img
      src="https://fuga.az/fuga/media/image10.png"
      className="h-[245px] w-full object-cover"
      alt=""
    />
  </div>
</div>

     </div>
     
</div>
  
    
    </>
  )
}

export default Media